import React, { useState } from "react";
import Modal from "./Modal";
import { ItemUI } from "../types/item";
import "./EditItemModal.scss";

interface EditItemModalProps {
  item: ItemUI;
  // just added via the + button: title it "Add item"
  isNew?: boolean;
  onSave: (name: string, price: number) => void;
  handleClose: () => void;
}

// edits a local draft; nothing reaches the item until Save. Price is kept as a
// string (not PriceInput, which only commits on blur) so an unblurred value
// isn't lost when Save is tapped.
const EditItemModal: React.FC<EditItemModalProps> = ({
  item,
  isNew = false,
  onSave,
  handleClose,
}) => {
  const [name, setName] = useState(item.name);
  const [priceStr, setPriceStr] = useState(
    item.price ? item.price.toFixed(2) : "",
  );

  const handleSave = () => {
    const num = parseFloat(priceStr);
    onSave(name.trim(), isNaN(num) ? item.price : num);
    handleClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleSave();
  };

  return (
    <Modal
      className="edit-item-modal"
      title={isNew ? "Add item" : "Edit item"}
      handleClose={handleClose}
    >
      <label>
        <span>Name</span>
        <input
          className="modal-input"
          type="text"
          placeholder="Item name"
          value={name}
          autoFocus
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </label>

      <label>
        <span>Price</span>
        <div className="price-field">
          <span className="currency">$</span>
          <input
            className="modal-input"
            type="text"
            inputMode="decimal"
            placeholder="0.00"
            value={priceStr}
            onChange={(e) =>
              setPriceStr(e.target.value.replace(/[^0-9.]/g, ""))
            }
            onFocus={(e) => e.target.select()}
            onKeyDown={handleKeyDown}
          />
        </div>
      </label>

      <div className="edit-item-buttons">
        <button className="modal-button secondary" onClick={handleClose}>
          Cancel
        </button>
        <button className="modal-button" onClick={handleSave}>
          Save
        </button>
      </div>
    </Modal>
  );
};

export default EditItemModal;
